import { ExternalLink } from "lucide-react";
import { track } from "../lib/analytics";
import { SpotifyIcon, YouTubeIcon } from "./icons/BrandIcons";

const DSPS = [
  { key: "spotifyURL", label: "Spotify", event: "spotify_click", accent: "text-[#1DB954] border-[#1DB954]/30", Icon: SpotifyIcon },
  { key: "appleMusicURL", label: "Apple Music", event: "apple_music_click", accent: "text-[#FA57C1] border-[#FA57C1]/30" },
  { key: "youtubeMusicURL", label: "YouTube Music", event: "youtube_music_click", accent: "text-[#FF0000] border-[#FF0000]/30", Icon: YouTubeIcon },
  { key: "youtubeURL", label: "YouTube", event: "youtube_click", accent: "text-[#FF0000] border-[#FF0000]/30", Icon: YouTubeIcon },
  { key: "amazonMusicURL", label: "Amazon Music", event: "amazon_music_click", accent: "text-[#00A8E1] border-[#00A8E1]/30" },
  { key: "deezerURL", label: "Deezer", event: "deezer_click", accent: "text-[#A238FF] border-[#A238FF]/30" },
  { key: "tidalURL", label: "Tidal", event: "tidal_click", accent: "text-white border-white/30" },
];

export default function DSPButtons({ release, size = "md" }) {
  const items = DSPS.filter((d) => release[d.key]);
  if (items.length === 0) return null;
  const pad = size === "sm" ? "px-3 py-2 text-[11px]" : "px-4 py-2.5 text-xs";
  return (
    <div className="flex flex-wrap gap-2" data-testid="dsp-buttons">
      {items.map((d) => (
        <a
          key={d.key}
          href={release[d.key]}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`dsp-${d.label.toLowerCase().replace(/\s+/g, "-")}`}
          onClick={() => d.event && track(d.event, { releaseId: release.internalId, metadata: { placement: "dsp_buttons" } })}
          className={`inline-flex items-center gap-1.5 rounded-full border bg-white/[0.03] font-semibold uppercase tracking-wide transition-transform active:scale-95 ${d.accent} ${pad}`}
        >
          {d.Icon ? <d.Icon size={14} /> : null}
          {d.label}
          <ExternalLink size={12} />
        </a>
      ))}
    </div>
  );
}
